import React from "react";
import { Link } from "react-router-dom";
import { SOCIAL_ICONS } from "./contant";
import { android, ios, virtuaFooter } from "../../assets";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <footer id="footer">
        <div className="container footer-content">
          <div className="footer">
            <div className="footer-left">
              <div className="footer-left-inner">
                <div className="footer-col">
                  <strong className="title strong">Explore</strong>
                  <ul className="list-none">
                    <li>
                      <a href="https://prime.virtua.com/">Virtua Prime</a>
                    </li>
                    <li>
                      <a href="https://island.virtua.com/">Virtua Island</a>
                    </li>
                    <li>
                      <a
                        href="https://landbots.virtua.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Land Bots
                      </a>
                    </li>
                    <li>
                    <a  href="https://labs.virtua.com/">
                    Virtua Labs
                    </a>
                  </li>
                  </ul>
                </div>
                <div className="footer-col">
                  <strong className="title strong">About</strong>
                  <ul className="list-none">
                    <li>
                      <a
                        href="https://virtua.gitbook.io/virtua-wiki/"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Wiki
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://virtua.gitbook.io/virtua-wiki/welcome-to-the-metaverse/the-virtua-team"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Our Team
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://blog.virtua.com/"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Blog
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-col">
                  <strong className="title strong">Links</strong>
                  <ul className="list-none">
                    <li>
                      <a
                        href="https://marketplace.virtua.com/"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Marketplace
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://virtua.gitbook.io/virtua-wiki/welcome-to-the-metaverse/tvk/prestige"
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        Prestige Program
                      </a>
                    </li>
                    <li>
                      <a href="https://virtua.com/tvk">Virtua Kolect</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center web-footer-text">
                <img src={virtuaFooter} alt="virtua" />
                <span className="title">
                  Virtua is a registered trademark of Virtua Limited. All logos
                  are registered trademarks of their respective owners. All
                  content of this document, unless otherwise credited, are
                  copyright @ {new Date().getUTCFullYear()} Virtua Limited.
                </span>
              </div>
            </div>
            <div className="footer-right">
              <div className="footer-right-inner">
                <div>
                  <strong className="title strong">Join Our Community</strong>

                  <ul className="list-none socialWrapper" social="ture">
                    {SOCIAL_ICONS.map((item) => (
                      <li key={item.id}>
                        <a
                          className="d-flex align-items-center justify-content-center socialLink"
                          href={item.href}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={item.src}
                            alt={item.alt}
                            className="imgIcon"
                          />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="footer-buttons">
                  <strong className="title strong">Download Our Apps</strong>
                  <div className="d-flex">
                    <a
                      href="https://apps.apple.com/pk/app/virtua-metaverse/id1597744060"
                      target="_blank"
                      className="btn"
                      rel="noreferrer"
                    >
                      <span className="icon">
                        <img src={ios} alt="ios" />
                      </span>
                      App Store
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.terravirtua.prod"
                      target="_blank"
                      className="btn"
                      rel="noreferrer"
                    >
                      <span className="icon">
                        <img src={android} alt="android" />
                      </span>
                      Google Play
                    </a>
                  </div>
                </div>
                <div className="mobile-footer-text">
                  <img src={virtuaFooter} alt="virtua" />
                  <span className="title">
                    Virtua is a registered trademark of Virtua Limited. All
                    logos are registered trademarks of their respective owners.
                    All content of this document, unless otherwise credited, are
                    copyright @  {new Date().getUTCFullYear()} Virtua Limited.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <ul className="list-none d-flex align-items-center justify-content-center user-guidelines">
        <li>
          <a
            href="https://virtua.com/user-guidelines"
            target="_blank"
            rel="noreferrer"
          >
            User Guidelines
          </a>
        </li>
        <li>
          <a
            href="https://virtua.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="https://virtua.com/terms-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>
        </li>
      </ul>
    </>
  );
};

export default Footer;
